import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataGridControlService {
  private clearActionsSource = new Subject<void>();

  clearActions$ = this.clearActionsSource.asObservable();

  clearSortingAndFiltering() {
    this.clearActionsSource.next();
  }
}